import React from "react";

export const UnaryOperatorSelect: React.FC<{
  value: string;
  onChange: (value: string) => void;
  className?: string;
}> = ({ value, onChange, className }) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(event.target.value);
  };

  return (
    <select value={value} onChange={handleChange} className={className}>
      <option value="+">+</option>
      <option value="-">-</option>
    </select>
  );
}; 